import apiClient from './api'

const mailTypeService = {
  async getMailTypes() {
    try {
      const response = await apiClient.get('/admin/mail-types')
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async createMailType(data) {
    try {
      const response = await apiClient.post('/admin/mail-types', data)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async updateMailType(id, data) {
    try {
      const response = await apiClient.put(`/admin/mail-types/${id}`, data)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async deleteMailType(id) {
    try {
      const response = await apiClient.delete(`/admin/mail-types/${id}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  }
}

export default mailTypeService 